export default __webpack_public_path__ + "static/media/Griffter.ef1b3399.png";